// extracted by mini-css-extract-plugin
export default {"faqStyles":"Faq_faqStyles__zx2zp","faqList":"Faq_faqList__0g1FE"};